<template>
  <div class="">
    <div class="bgfff w100b pb20 pl20 pr20 pt20 min-height">

      <Col class="demo-spin-col" style="height: 500px" v-if="loading">
      <Spin fix>
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
        <div>Loading</div>
      </Spin>
      </Col>

      <ul class="top-tab">
        <li class="cp" :class="activeInfo.activeBank === (item.bankName+index) && 'active'" v-for="(item, index) in cuBankList" :key="item.bankName+index" @click="changeActiveBank(item.bankName+index, item)">{{item.bankName}}</li>
      </ul>

      <discount-rate-card class="imageDom" ref="imageDom" v-if="activeInfo.activeType === 'rzline' && activeInfo.cuDiscountRate" :cuDiscountRate="activeInfo.cuDiscountRate" :levelBankList="activeInfo.levelBankList" :logo="activeInfo.logo" :bank="activeInfo.bankName" :type="activeInfo.activeType"></discount-rate-card>

    </div>
  </div>
</template>

<script>
import store from '@/store/store';
import Table from '../module/Table.vue';
import DiscountRateCardFm from '../common/DiscountRateCardFm.vue';
import { querySingle, queryBankList, refreshBankRate } from '@/api/discountBankQuote.js'
import DiscountRateCard from '../common/DiscountRateCard.vue';
import DiscountRateCardXY from '../common/DiscountRateCardXY.vue';
import html2canvas from 'html2canvas';
export default {
  store, // 引用
  name: "discountRateMenu",
  provide () {
    return {
      discountWebBaseCom: this
    }
  },
  props: ['bankInfo'],
  data () {
    return {
      // 京东利率
      quoteList: [],
      // 众邦振兴的利率
      discountRateVoList: {},
      cuDiscountRateVoList: {},
      // 富民利率
      fmRate: null,
      // 融资线配置的利率
      // rzlineConfigBankRateList: [],
      // 当前的银行列表
      cuBankList: [],
      activeInfo: {
        activeBank: null,
        // 当前选择的银行利率的渠道
        activeType: null,
        cuDiscountRate: [],
        levelBankList: null,
        logo: null,
        bankName: null,
        updateTime: ''
      },
      bankList: [],
      loading: true
    }
  },
  components: {
    DiscountRateCardFm,
    DiscountRateCard,
    DiscountRateCardXY
  },
  methods: {
    // 选择银行
    changeActiveBank (bank, info) {
      console.log(bank, info, '--');
      console.log(this.cuBankList);
      this.activeInfo.activeBank = bank;
      this.activeInfo.bankName = info.bankName;
      this.activeInfo.logo = info.bankCode
      // this.activeInfo.cuDiscountRate = []
      // this.activeInfo.levelBankList = []
      // this.activeInfo.updateTime = info.updateTime
      this.querryBankRate()
    },
    // // 初始化rzl配置的银行利率
    // async getRzlineConfigBankRate () {
    //   const res = await queryAll();
    //   console.log(res, '===========');
    //   // this.rzlineConfigBankRateList = res;
    //   console.log('resolve')
    //   return res;
    // },
    // 票面范围处理
    getScope (start, end, index) {
      if (index == 0) {
        return "[" + start.div(10000).toFixed(0) + "," + end.div(10000).toFixed(0) + "]";
      } else {
        return "[" + start.div(10000).toFixed(0) + "," + end.div(10000).toFixed(0) + ")";
      }
    },
    // 利率
    changeRate (rate) {
      if (rate.indexOf('%') > -1) {
        return rate;
      } else {
        return Number(rate).mul(100).toFixed('2') + '%';
      }
    },
    // 查询银行报价
    async querryBankRate () {
      this.addLoading();
      const res = await querySingle(this.activeInfo.logo).then(res => {
        this.loading = false;
        console.log(res);
        if (res) {
          let i;
          for (let item in this.cuBankList) {
            if (this.cuBankList[item].bankCode === this.activeInfo.logo) {
              i = item;
              this.cuBankList[item] = {
                bankName: res.bankName,
                type: 'rzline',
                bankCode: res.logo || res.bannkCode,
                cuDiscountRate: res.cuDiscountRate,
                levelBankList: res.levelBankList,
                updateTime: res.updateTime
              }
            }
          }
          this.activeInfo.logo = res.logo || res.bankCode
          this.activeInfo.bankName = res.bankName
          this.activeInfo.activeType = 'rzline';
          this.activeInfo.cuDiscountRate = Object.assign([], this.activeInfo.cuDiscountRate, res.cuDiscountRate)
          this.activeInfo.levelBankList = Object.assign([], this.activeInfo.levelBankList, res.levelBankList)
          this.$set(this.activeInfo, 'cuDiscountRate', res.cuDiscountRate)
          this.activeInfo.updateTime = res.updateTime
        }
      }).catch(err => {
        // 报错处理
        console.log(err);
        this.activeInfo.cuDiscountRate = []
        this.activeInfo.levelBankList = []
        this.activeInfo.updateTime = ''
      })
    },
    // 刷新银行报价
    async refreshBankRate () {
      this.addLoading();
      const res = await refreshBankRate(this.activeInfo.logo).then(res => {
        this.loading = false;
        console.log(res);
        if (res) {
          let i;
          for (let item in this.cuBankList) {
            if (this.cuBankList[item].bankCode === this.activeInfo.logo) {
              i = item;
              this.cuBankList[item] = {
                bankName: res.bankName,
                type: 'rzline',
                bankCode: res.logo || res.bannkCode,
                cuDiscountRate: res.cuDiscountRate,
                levelBankList: res.levelBankList,
                updateTime: res.updateTime
              }
            }
          }
          this.activeInfo.logo = res.logo || res.bankCode
          this.activeInfo.bankName = res.bankName
          this.activeInfo.activeType = 'rzline';
          this.activeInfo.cuDiscountRate = Object.assign([], this.activeInfo.cuDiscountRate, res.cuDiscountRate)
          this.activeInfo.levelBankList = Object.assign([], this.activeInfo.levelBankList, res.levelBankList)
          this.$set(this.activeInfo, 'cuDiscountRate', res.cuDiscountRate)
          this.activeInfo.updateTime = res.updateTime
        }
      }).catch(err => {
        // 报错处理
        console.log(err);
        this.activeInfo.cuDiscountRate = []
        this.activeInfo.levelBankList = []
        this.activeInfo.updateTime = ''
      })
    },
    // 查询银行列表
    async querryBankList () {
      // this.addLoading();
      return queryBankList()
    },
    downloadPage () {
      this.addLoading()
      let htmlDom = document.querySelector('.imageDom')
      console.log(htmlDom, htmlDom.clientWidth, htmlDom.clientHeight)
      html2canvas(htmlDom, {
        backgroundColor: '#ffffff',
        logging: false, //日志开关，便于查看html2canvas的内部执行流程
        width: htmlDom.clientWidth + 12, //dom 原始宽度
        height: htmlDom.clientHeight + 12,
        scrollY: 30,
        scrollX: 0,
        useCORS: true // 【重要】开启跨域配置
      }).then(canvas => {
        var imgData = canvas.toDataURL("image/png");
        this.fileDownload(imgData);
      })
    },
    fileDownload (downloadUrl) {
      let aLink = document.createElement("a");
      aLink.crossorigin = 'anonymous' // 解决图片跨域问题
      aLink.style.display = "none";
      aLink.href = downloadUrl;
      aLink.download = `${this.activeInfo.bankName}.png`;
      // 触发点击-然后移除
      document.body.appendChild(aLink);
      aLink.click();
      document.body.removeChild(aLink);
      this.removeLoading()
    }
  },
  created () {
    this.quoteList = this.$store.state.discountRate;

    this.querryBankList().then(res => {
      this.loading = false;
      res.data.data && this.cuBankList.push(...res.data.data.map(item => {
        return {
          bankName: item.bankName,
          type: 'rzline',
          bankCode: item.bankCode,
          cuDiscountRate: item.cuDiscountRate,
          levelBankList: item.levelBankList,
          updateTime: item.updateTime
        }
      }))
      console.log(res.data.data, this.cuBankList);
      if (this.bankInfo.bankCode) {
        this.changeActiveBank(this.bankInfo.bankName + `${this.cuBankList.findIndex(item => item.bankCode === this.bankInfo.bankCode)}`, this.bankInfo)
      } else {
        this.changeActiveBank(this.cuBankList[0].bankName + '0', this.cuBankList[0])
      }
    })
    // Promise.all([this.refreshBankList()]).then((res) => {
    //   console.log('----', res);
    //   this.loading = false;
    //   console.log(res, '=======');

    //   res && this.cuBankList.push(...res.map(item => {
    //     return {
    //       bankName: item.bankName,
    //       type: 'rzline',
    //       bankCode: item.logo,
    //       cuDiscountRate: item.cuDiscountRate,
    //       levelBankList: item.levelBankList,
    //       updateTime: item.updateTime
    //     }
    //   }))
    //   // 选择银行
    //   this.changeActiveBank(this.cuBankList[0].bankName + '0', this.cuBankList[0])
    // }).catch((err) => {
    //   console.log(err)
    // })
  },
}
</script>
<style lang="scss" scoped>
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.min-height {
  min-height: 500px;
}
.top-tab {
  display: flex;
  align-items: center;
  list-style: none;
  position: relative;
  margin-bottom: 30px;
  li {
    padding: 0 20px;
    position: relative;
    font-size: 16px;
    font-weight: bold;
    color: #333;
  }
  li.active {
    color: #e1241a;
  }
  li::after {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 2px;
    height: 11px;
    background-color: #e1e1e1;
  }
  li:last-child::before {
    content: '';
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 2px;
    height: 11px;
    background-color: #e1e1e1;
  }
}

.jdFont {
  font-family: 'jd-fonts';
}
</style>



// WEBPACK FOOTER //
// src/components/discountRate/DiscountRateWebBase.vue